import { IconButton } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  SET_RECIPE_QUANTITY,
  UNSELECT_RECIPE,
} from "../constants/reducerEvents";
import RecipePreview from "./RecipePreview";
import SelectedRecepie from "./SelectedRecipe";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
export default function RecipeQuantity({ recipe }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onRecipeClick = () => {
    navigate(`/recipe/${recipe.recipe.id}`);
  };
  const removeRecipe = () => {
    dispatch({ type: UNSELECT_RECIPE, payload: recipe.recipe });
  };
  const addQuantity = () => {
    dispatch({
      type: SET_RECIPE_QUANTITY,
      payload: { url: recipe.recipe.url, quantity: recipe.quantity + 1 },
    });
  };
  const updateQuantity = (newQuantity) => {
    if (!/^\d+$/.test(newQuantity)) {
      if (newQuantity === "") {
        dispatch({
          type: SET_RECIPE_QUANTITY,
          payload: { url: recipe.recipe.url, quantity: 0 },
        });
      }
      return;
    }
    dispatch({
      type: SET_RECIPE_QUANTITY,
      payload: { url: recipe.recipe.url, quantity: parseInt(newQuantity) },
    });
  };
  const removeQuantity = () => {
    if (recipe.quantity > 1) {
      dispatch({
        type: SET_RECIPE_QUANTITY,
        payload: { url: recipe.recipe.url, quantity: recipe.quantity - 1 },
      });
    }
  };
  return (
    <div style={{ height: "200px" }}>
      <SelectedRecepie
        recipe={recipe.recipe}
        onClick={onRecipeClick}
        removeRecipe={removeRecipe}
      />
      <div
        style={{
          display: "flex",
          marginLeft: "10px",
          marginRight: "10px",
        }}
      >
        <IconButton onClick={removeQuantity}>
          <RemoveIcon />
        </IconButton>
        <div
          style={{
            flexGrow: 1,
            textAlign: "center",
            paddingTop: "10px",
          }}
        >
          <input
            type="text"
            style={{ border: "none", width: "20px", textAlign: "center" }}
            value={recipe.quantity}
            onChange={(e) => updateQuantity(e.target.value)}
            onBlur={() => {
              if (recipe.quantity === 0) {
                updateQuantity(recipe.recipe.recipeYield);
              }
            }}
          ></input>
        </div>
        <IconButton onClick={addQuantity}>
          <AddIcon />
        </IconButton>
      </div>
    </div>
  );
}
